import React, { useContext } from 'react';
import { Flex } from 'antd';
import dayjs from 'dayjs';

import DateRangePickerExtended, {
  PickerType,
} from '@totem/components/common/dateRangePicker/dateRangePickerExtended';
import EmployeeUtilizationContext from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContext';
import FiltersContainer from '@totem/components/ui_components/filters/FiltersContainer';
import FiltersTitle from '@totem/components/ui_components/filters/FiltersTitle';
import { isNotNull } from '@totem/utilities/common';
import { formatDate } from '@totem/utilities/timeUtilities';

type Props = {
  defaultTimeFrame?: PickerType;
};

const EmployeeUtilizationFilters = ({ defaultTimeFrame }: Props) => {
  const { input, setInput } = useContext(EmployeeUtilizationContext);

  return (
    <FiltersContainer>
      <Flex justify="space-between" align="center">
        <FiltersTitle>
          Period:{'  '}
          {isNotNull(input) ? formatDate(input.startTime) : ''} -
          {isNotNull(input) ? formatDate(input.endTime) : ''}
        </FiltersTitle>
        <div style={{ marginRight: 32 }}>
          <DateRangePickerExtended
            defaultTimeFrame={
              isNotNull(defaultTimeFrame) ? defaultTimeFrame : 'week'
            }
            startTime={dayjs(input.startTime)}
            endTime={dayjs(input.endTime)}
            onChange={(start, end) => {
              setInput({
                startTime: start.toISOString(),
                endTime: end.toISOString(),
              });
            }}
          />
        </div>
      </Flex>
    </FiltersContainer>
  );
};

export default EmployeeUtilizationFilters;
